// import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

// const TabsFilterContext = createContext();

// export function TabsFilterProvider({ children, setFilterSelection }) {
//   const [activeTab, setActiveTab] = useState("type");

//   // الحالات الافتراضية
//   const [typeSelection, setTypeSelection] = useState([]);
//   const [availabilitySelection, setAvailabilitySelection] = useState([]);
//   const [progressSelection, setProgressSelection] = useState([
//     "excellent",
//     "good",
//     "normal",
//     "bad",
//   ]);
  
//   // 🔥 إضافة حالة تاريخ الحجز (القيمة الافتراضية هي تاريخ اليوم بصيغة ISO)
//   const [bookingDate, setBookingDate] = useState(new Date().toISOString());

//   /**
//    * المزامنة عند بداية التشغيل (Mount)
//    */
//   useEffect(() => {
//     if (setFilterSelection) {
//       setFilterSelection((prev) => ({
//         ...prev,
//         progressCategories: ["excellent", "good", "normal", "bad"],
//         cancelledTypes: [],
//         cancelledAvailability: [],
//         booking_date: new Date().toISOString(), // القيمة الابتدائية للباك
//       }));
//     }
//   }, [setFilterSelection]);

//   const handleFilterChange = useCallback(
//     (mode, dataOrUpdater) => {
//       let valueToUpdate;

//       // تحديد القيمة الجديدة بناءً على النمط (Function updater أو Direct data)
//       if (typeof dataOrUpdater === "function") {
//         if (mode === "type") valueToUpdate = dataOrUpdater(typeSelection);
//         else if (mode === "availability") valueToUpdate = dataOrUpdater(availabilitySelection);
//         else if (mode === "construction") valueToUpdate = dataOrUpdater(progressSelection);
//         else if (mode === "bookingDate") valueToUpdate = dataOrUpdater(bookingDate);
//         else valueToUpdate = [];
//       } else {
//         valueToUpdate = dataOrUpdater;
//       }

//       // تحديث الـ State المحلية في الـ Context
//       if (mode === "type") setTypeSelection(valueToUpdate);
//       else if (mode === "availability") setAvailabilitySelection(valueToUpdate);
//       else if (mode === "construction") setProgressSelection(valueToUpdate);
//       else if (mode === "bookingDate") setBookingDate(valueToUpdate);

//       // تحديث الـ State الخارجية (التي يراها الـ Parent والباك إند)
//       if (setFilterSelection) {
//         setFilterSelection((prev) => ({
//           ...prev,
//           cancelledTypes: mode === "type" ? valueToUpdate : prev.cancelledTypes,
//           cancelledAvailability: mode === "availability" ? valueToUpdate : prev.cancelledAvailability,
//           progressCategories: mode === "construction" ? valueToUpdate : prev.progressCategories,
//           booking_date: mode === "bookingDate" ? valueToUpdate : prev.booking_date, // 🔥 الربط مع الباك
//           activeTab: mode,
//         }));
//       }
//     },
//     [typeSelection, availabilitySelection, progressSelection, bookingDate, setFilterSelection]
//   );

//   const setActiveTabOnly = useCallback((tab) => {
//     setActiveTab(tab);
//     if (setFilterSelection) {
//       setFilterSelection(prev => ({ ...prev, activeTab: tab }));
//     }
//   }, [setFilterSelection]);

//   const resetTypeSelection = useCallback(() => {
//     setTypeSelection([]);
//     handleFilterChange("type", []);
//   }, [handleFilterChange]);

//   // تمرير القيم الجديدة في الـ Context
//   const value = {
//     activeTab,
//     setActiveTab: setActiveTabOnly,
//     typeSelection,
//     setTypeSelection,
//     availabilitySelection,
//     setAvailabilitySelection,
//     progressSelection,
//     setProgressSelection,
//     bookingDate, // 🔥 متاح الآن للاستخدام في BookingDate component
//     onFilterChange: handleFilterChange,
//     resetTypeSelection,
//   };

//   return (
//     <TabsFilterContext.Provider value={value}>
//       {children}
//     </TabsFilterContext.Provider>
//   );
// }

// export function useTabsFilter() {
//   const context = useContext(TabsFilterContext);
//   if (!context) {
//     throw new Error("useTabsFilter must be used within TabsFilterProvider");
//   }
//   return context;
// }
// 7/4






import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const TabsFilterContext = createContext();

export function TabsFilterProvider({ children, setFilterSelection }) {
  const [activeTab, setActiveTab] = useState("type");

  // الحالات الافتراضية
  const [typeSelection, setTypeSelection] = useState([]);
  const [availabilitySelection, setAvailabilitySelection] = useState([]);
  const [progressSelection, setProgressSelection] = useState([
    "excellent",
    "good",
    "normal",
    "bad",
  ]);
  
  // 🔥 جعل القيمة الافتراضية نص فارغ ليدعم عرض "المحجوز فقط" كديفولت
  const [bookingDate, setBookingDate] = useState("");

  /**
   * المزامنة عند بداية التشغيل (Mount)
   */
  useEffect(() => {
    if (setFilterSelection) {
      setFilterSelection((prev) => ({
        ...prev,
        progressCategories: ["excellent", "good", "normal", "bad"],
        cancelledTypes: [],
        cancelledAvailability: [],
        booking_date: "", // 🔥 القيمة الابتدائية للباك إند فارغة أيضاً
        activeTab: "type",
      }));
    }
  }, [setFilterSelection]);

  const handleFilterChange = useCallback(
    (mode, dataOrUpdater) => {
      let valueToUpdate;

      // تحديد القيمة الجديدة بناءً على النمط (Function updater أو Direct data)
      if (typeof dataOrUpdater === "function") {
        if (mode === "type") valueToUpdate = dataOrUpdater(typeSelection);
        else if (mode === "availability") valueToUpdate = dataOrUpdater(availabilitySelection);
        else if (mode === "construction") valueToUpdate = dataOrUpdater(progressSelection);
        else if (mode === "bookingDate") valueToUpdate = dataOrUpdater(bookingDate);
        else valueToUpdate = [];
      } else {
        valueToUpdate = dataOrUpdater;
      }

      // تحديث الـ State المحلية في الـ Context
      if (mode === "type") setTypeSelection(valueToUpdate);
      else if (mode === "availability") setAvailabilitySelection(valueToUpdate);
      else if (mode === "construction") setProgressSelection(valueToUpdate);
      else if (mode === "bookingDate") setBookingDate(valueToUpdate);

      // تحديث الـ State الخارجية (التي يراها الـ Parent والباك إند)
      if (setFilterSelection) {
        setFilterSelection((prev) => ({
          ...prev,
          cancelledTypes: mode === "type" ? valueToUpdate : prev.cancelledTypes,
          cancelledAvailability: mode === "availability" ? valueToUpdate : prev.cancelledAvailability,
          progressCategories: mode === "construction" ? valueToUpdate : prev.progressCategories,
          booking_date: mode === "bookingDate" ? valueToUpdate : prev.booking_date, // 🔥 الربط مع الباك
          activeTab: mode,
        }));
      }
    },
    [typeSelection, availabilitySelection, progressSelection, bookingDate, setFilterSelection]
  );

  const setActiveTabOnly = useCallback((tab) => {
    setActiveTab(tab);
    if (setFilterSelection) {
      setFilterSelection(prev => ({ ...prev, activeTab: tab }));
    }
  }, [setFilterSelection]);

  const resetTypeSelection = useCallback(() => {
    setTypeSelection([]);
    handleFilterChange("type", []);
  }, [handleFilterChange]);

  // تمرير القيم في الـ Context
  const value = {
    activeTab,
    setActiveTab: setActiveTabOnly,
    typeSelection,
    setTypeSelection,
    availabilitySelection,
    setAvailabilitySelection,
    progressSelection,
    setProgressSelection,
    bookingDate, // 🔥 متاح للاستخدام في BookingDate component و FilterContext
    onFilterChange: handleFilterChange,
    resetTypeSelection,
  };

  return (
    <TabsFilterContext.Provider value={value}>
      {children}
    </TabsFilterContext.Provider>
  );
}

export function useTabsFilter() {
  const context = useContext(TabsFilterContext);
  if (!context) {
    throw new Error("useTabsFilter must be used within TabsFilterProvider");
  }
  return context;
}









// import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

// const TabsFilterContext = createContext();

// export function TabsFilterProvider({ children, setFilterSelection }) {
//   const [activeTab, setActiveTab] = useState("type");

//   // الحالات الافتراضية
//   const [typeSelection, setTypeSelection] = useState([]);
//   const [availabilitySelection, setAvailabilitySelection] = useState([]);
//   const [progressSelection, setProgressSelection] = useState([
//     "excellent",
//     "good",
//     "normal",
//     "bad",
//   ]);

//   /**
//    * 🔥 التعديل الجوهري: المزامنة عند بداية التشغيل (Mount)
//    * هذا الجزء يضمن إرسال الحالات الأربعة للـ SVG والـ Parent فور تحميل الصفحة (الريفرش)
//    */
//   useEffect(() => {
//     if (setFilterSelection) {
//       setFilterSelection((prev) => ({
//         ...prev,
//         progressCategories: ["excellent", "good", "normal", "bad"],
//         cancelledTypes: [],
//         cancelledAvailability: [],
//       }));
//     }
//   }, [setFilterSelection]);

//   const handleFilterChange = useCallback(
//     (mode, dataOrUpdater) => {
//       let cancelled;

//       if (typeof dataOrUpdater === "function") {
//         if (mode === "type") cancelled = dataOrUpdater(typeSelection);
//         else if (mode === "availability") cancelled = dataOrUpdater(availabilitySelection);
//         else if (mode === "construction") cancelled = dataOrUpdater(progressSelection);
//         else cancelled = [];
//       } else {
//         cancelled = dataOrUpdater;
//       }

//       cancelled = Array.isArray(cancelled) ? cancelled : [];

//       // تحديث الـ State المحلية في الـ Context
//       if (mode === "type") setTypeSelection(cancelled);
//       else if (mode === "availability") setAvailabilitySelection(cancelled);
//       else if (mode === "construction") setProgressSelection(cancelled);

//       // تحديث الـ State الخارجية (التي يراها الـ SVG والـ Parent)
//       if (setFilterSelection) {
//         setFilterSelection((prev) => ({
//           ...prev,
//           cancelledTypes: mode === "type" ? cancelled : prev.cancelledTypes,
//           cancelledAvailability: mode === "availability" ? cancelled : prev.cancelledAvailability,
//           progressCategories: mode === "construction" ? cancelled : prev.progressCategories,
//           activeTab: mode,
//         }));
//       }
//     },
//     [typeSelection, availabilitySelection, progressSelection, setFilterSelection]
//   );

//   /**
//    * تغيير التاب بدون عمل Reset للقيم المختارة
//    * هذا يضمن أن المستخدم إذا اختار فلاتر معينة في Progress ثم انتقل لتاب آخر وعاد، يجدها كما هي
//    */
//   const setActiveTabOnly = useCallback((tab) => {
//     setActiveTab(tab);
    
//     // نقوم بتحديث الـ activeTab في الـ Parent أيضاً لضمان مزامنة الألوان في الـ SVG
//     if (setFilterSelection) {
//       setFilterSelection(prev => ({ ...prev, activeTab: tab }));
//     }
//   }, [setFilterSelection]);

//   const resetTypeSelection = useCallback(() => {
//     setTypeSelection([]);
//     handleFilterChange("type", []);
//   }, [handleFilterChange]);

//   const value = {
//     activeTab,
//     setActiveTab: setActiveTabOnly,
//     typeSelection,
//     setTypeSelection,
//     availabilitySelection,
//     setAvailabilitySelection,
//     progressSelection,
//     setProgressSelection,
//     onFilterChange: handleFilterChange,
//     resetTypeSelection,
//   };

//   return (
//     <TabsFilterContext.Provider value={value}>
//       {children}
//     </TabsFilterContext.Provider>
//   );
// }

// export function useTabsFilter() {
//   const context = useContext(TabsFilterContext);
//   if (!context) {
//     throw new Error("useTabsFilter must be used within TabsFilterProvider");
//   }
//   return context;
// }